import { Box, Flex } from 'reflexbox';

import * as graphql from 'generated/graphql';
import LearningEventCard from 'packages/kakapo-ui-application/pages/learning/components/LearningEventCard';
import { SectionTitle } from 'packages/kakapo-ui-kit/components/common/Headings';
import Spinner from 'packages/kakapo-ui-kit/components/common/Spinner';

const LearningEventsSlider = ({ title }: { title: string }) => {
	const { data } = graphql.useAttendingLearningEventsQuery();

	const events = data?.viewer.attendingLearningEvents.edges.filter(({ node }) => !node.isArchived);

	return (
		<>
			{events ? (
				events.length > 0 ? (
					<>
						<SectionTitle>{title}</SectionTitle>

						<Flex ml={-3} flexWrap="wrap">
							{events.map(({ node }) => (
								<Box key={node.id} width={[1, 1 / 2, 1 / 4, 1 / 4]} mt={3} pl={3}>
									<LearningEventCard event={node as graphql.LearningEvent} />
								</Box>
							))}
						</Flex>
					</>
				) : null
			) : (
				<Spinner isLoading size="18px" />
			)}
		</>
	);
};

export default LearningEventsSlider;
